import axios from 'axios';

const PREFIJO="/api/NgSlCr/";

export default {
    cambioEstado(estado,item) {
        const dto={
            id:item.ndt5,
            bdt1:estado,
        };
        return axios.post(`${PREFIJO}VmDscSCr`,dto);
    }
};
